module.exports = "<div class=\"auth-app\">\n\t<ul class=\"auth-app-list\">\n\t\t<li>\n\t\t\t<a href=\"https://itunes.apple.com/ru/app/ugona.net+/id842846596?mt=8\" class=\"auth-app-link\">\n\t\t\t\t<span class=\"icon-apple\"></span>\n\t\t\t</a>\n\n\t\t</li>\n\t\t<li>\n\t\t\t<a href=\"https://play.google.com/store/apps/details?id=net.ugona.plus&hl=ru\" class=\"auth-app-link\">\n\t\t\t\t<span class=\"icon-android\"></span>\n\t\t\t</a>\n\n\t\t</li>\n\t</ul>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/auth/nav-app/navapp.component.html
// module id = ./src/app/view/auth/nav-app/navapp.component.html
// module chunks = main